import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { authGoogleSession } from "@/lib/api";
import { useApp } from "@/context/AppContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useApp();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const roleParam = new URLSearchParams(location.search).get("role");
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const u = await authGoogleSession(sid, roleParam);
        await refreshUser();
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${u?.name || ""}!`);
        navigate(u?.role === "employer" ? "/employer" : "/worker", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-muted-foreground" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      <p className="text-sm">Signing you in…</p>
    </div>
  );
}
